<template>
  <div class="exam">

    <div v-if="test.minutes_left > 0" class="exam--runnning">


      <div class="exam__meta flex justify-between lg:block mb-2 lg:mb-0">
        <question-index :questions="exam.questions.length" :current="index + 1"/>
        <exam-timer :exam="exam" :test="test"/>
      </div>

      <questions v-if="index != null"
                 :exam="exam"
                 :test="test"
                 :index="index"
                 :questions="exam.questions"
                 :is-first-question="isFirstQuestion"
                 @indexChanged="updateIndex"
                 @selfcheck="maybeShowExamToSelfcheckTransition"
                 @finished="questionsFinished"
      ></questions>

      <div v-if="showSelfcheckTransition" class="row custom-questions__wrapper">
        <exam-selfcheck-transition :exam="exam" :test="test" @continue="startSelfcontrol"></exam-selfcheck-transition>
      </div>

      <div v-if="showSelfcontrol" class="row custom-questions__wrapper">
        <selfcontrol :data="freeLocalControlData" :exam="exam" :test="test" @finished="onSelfcontrolFinished"></selfcontrol>
      </div>

      <div v-if="results" class="">
        <p class="text-center">
          <i class="fa fa-spinner fa-4x text-secondary-500 fa-spin"></i>
        </p>
      </div>
    </div>

    <div v-else class="exam--over">
      <alert :type="'danger'">
        <span class="font-medium">Achtung!</span> Prüfungen abgelaufen vor {{ -test.minutes_left }} Minuten
      </alert>
    </div>
  </div>
</template>

<script>

import ExamSelfcheckTransition from "@/Shared/Exam/ExamSelfcheckTransition.vue";

export default {
  components: {ExamSelfcheckTransition},

  props: {
    exam: Object,
    test: Object,
    startIndex: Number,
    /**
     * Free Control Data is data that has to be controlled by the user
     * it only comes back if the test has some free text questions
     */
    freeControlData: {
      type: Array,
      required: false,
    },
  },

  data() {
    return {
      index: null,
      currentStep: 'questions',
      isFirstQuestion: true,
      showSelfcontrol: false,
      showSelfcheckTransition: false,
      hasResults: false,
      results: null,
      freeLocalControlData: null,
    }
  },

  mounted() {
    this.index = this.startIndex
    if( this.freeControlData ) {
      this.showSelfcheckTransition = true
      this.freeLocalControlData = this.freeControlData
    }
  },

  methods: {
    questionsFinished(results) {
      this.results = results
      this.goToResultPage()
    },

    testPublished() {

    },

    updateIndex(value) {
      this.index = value
    },

    maybeShowExamToSelfcheckTransition( response ) {
      if(response && response.freetext_data ) {
        this.freeLocalControlData = response.freetext_data
      }
      this.showSelfcontrol = false
      this.showSelfcheckTransition = true
    },

    startSelfcontrol( response ) {
      if(response && response.freetext_data ) {
        this.freeLocalControlData = response.freetext_data
      }
      this.showSelfcheckTransition = false
      this.showSelfcontrol = true
    },

    onSelfcontrolFinished() {
      this.results = true
      this.goToResultPage()
    },

    goToResultPage: function() {
      location.href = `/testergebnis/${this.test.id}`
    },

  },
}
</script>

<style scoped>

</style>
